import React, { useState, useEffect } from "react";
import { CircularProgress, Typography } from "@mui/material";
import Box from "@mui/material/Box";

const LoadingScreen = ({ show }) => {
  // Array of funny fake progress messages
  const fakeProgressMessages = [
    "Rewriting all code in Rust...",
    "Asking ChatGPT for help...",
    "Blaming the backend team...",
    "Downloading more RAM...",
    "Brewing coffee for developers...",
    "Convincing AI not to take over...",
    "Counting to infinity...",
    "Generating excuses for bugs...",
    "Negotiating with the server...",
    "Pretending to understand the codebase...",
    "Searching Stack Overflow...",
    "Spinning up the hamster...",
    "Teaching AI to feel emotions...",
    "Turning it off and on again...",
    "Updating Adobe Reader...",
    "Waiting for the intern to fix it...",
    "Wondering why this is taking so long...",
    "Consulting ancient programming texts...",
    "Sacrificing a rubber duck to the code gods...",
    "Trying to remember why we wrote this code...",
    "Asking the server to shut up...",
    "Deleting System32 for performance...",
    "Arguing with the database...",
    "Summoning the debugging demon...",
    "Politely asking bugs to leave...",
    "Translating code from developer to computer...",
    "Untangling spaghetti code...",
    "Feeding the server hamsters...",
    "Calculating the meaning of life...",
    "Convincing CSS to cooperate...",
    "Bribing the compiler with cookies...",
    "Reticulating splines...",
    "Questioning life choices...",
    "Trying to understand our own code...",
    "Sending thoughts and prayers to the server...",
    "Applying duct tape to the codebase...",
    "Telling the CPU to hurry up...",
    "Performing ritual code dance...",
    "Waiting for coffee to kick in...",
    "Contemplating a career change...",
    "Promising to write better comments next time...",
    "Asking the server to take a break...",
    "Feeding the hamster more food...",
    "Waiting for the server to respond...",
    "Pretending to be a magician...",
    "Asking the server to stop spamming...",
  ];

  // Initialize with a random message instead of "Loading..."
  const [message, setMessage] = useState(
    fakeProgressMessages[
      Math.floor(Math.random() * fakeProgressMessages.length)
    ]
  );
  const [extendedLoading, setExtendedLoading] = useState(false);

  // Determine if we should extend loading time (50% chance)
  useEffect(() => {
    if (show) {
      // 50% chance to enable extended loading
      setExtendedLoading(Math.random() < 0.5);
    }
  }, [show]);

  // Change message every 2 seconds
  useEffect(() => {
    if (!show) return;

    const interval = setInterval(() => {
      const randomIndex = Math.floor(
        Math.random() * fakeProgressMessages.length
      );
      setMessage(fakeProgressMessages[randomIndex]);
    }, 2000);

    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, [show]);

  // Notify parent component about loading completion
  useEffect(() => {
    if (!show || !extendedLoading) return;

    // If extended loading is enabled, add an additional 2-4 second delay
    const extraDelay = 2000 + Math.random() * 2000;

    // This is just to keep the extended loading state active
    // The actual loading time is controlled by the parent component
    const timer = setTimeout(() => {
      // We don't need to do anything here, just keeping the loading screen visible
    }, extraDelay);

    return () => clearTimeout(timer);
  }, [show, extendedLoading]);

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgb(40, 44, 52)", // Changed to match Navigation bar color
        zIndex: 9999999999999,
        display: show ? "flex" : "none",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        opacity: show ? 1 : 0,
        transition: "opacity 0.5s ease-in-out",
      }}
    >
      <Box
        component="img"
        src="/logo/logolarge.webp"
        alt="Loading Logo"
        sx={{
          width: 210,
          height: 210,
          mb: 4,
        }}
      />
      <CircularProgress size={40} sx={{ mb: 2 }} />
      <Typography variant="h6" sx={{ color: "white" }}>
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingScreen;
